import { render } from "./VentasCrear.vue?vue&type=template&id=61046084&scoped=true"
import script from "./VentasCrear.vue?vue&type=script&lang=js"
export * from "./VentasCrear.vue?vue&type=script&lang=js"

import "./VentasCrear.vue?vue&type=style&index=0&id=61046084&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\clogistica_front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61046084"]])

export default __exports__